module.exports = __webpack_public_path__ + "static/media/checkbox.50294de8.svg";